"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const spacex_1 = require("../lib/spacex");
class AdsStore {
    constructor(config) {
        this.AdType = config.adType;
        this.pubId = config.pubId;
        this.isWemedia = config.isIndexCp === 0;
        spacex_1.getAbSlotid('bottom', (slotid) => {
            console.log('实验平台广告ID [bottom]', slotid);
            this.slotId = slotid || config.slotId;
        });
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], AdsStore.prototype, "slotId", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], AdsStore.prototype, "AdType", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], AdsStore.prototype, "pubId", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], AdsStore.prototype, "isWemedia", void 0);
exports.default = AdsStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRzRm9vdGVyU3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhZHNGb290ZXJTdG9yZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFBa0M7QUFFbEMsMENBQTRDO0FBUzVDLE1BQXFCLFFBQVE7SUFLM0IsWUFBWSxNQUFpQjtRQUMzQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFFNUIsSUFBSSxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDO1FBQzFCLElBQUksQ0FBQyxTQUFTLEdBQUcsTUFBTSxDQUFDLFNBQVMsS0FBSyxDQUFDLENBQUM7UUFFeEMsb0JBQVcsQ0FBQyxRQUFRLEVBQUUsQ0FBQyxNQUFNLEVBQUUsRUFBRTtZQUMvQixPQUFPLENBQUMsR0FBRyxDQUFDLG1CQUFtQixFQUFFLE1BQU0sQ0FBQyxDQUFDO1lBQ3pDLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxJQUFJLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFDeEMsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0NBQ0Y7QUFmYTtJQUFYLGlCQUFVOzt3Q0FBdUI7QUFDdEI7SUFBWCxpQkFBVTs7d0NBQXVCO0FBQ3RCO0lBQVgsaUJBQVU7O3VDQUFzQjtBQUNyQjtJQUFYLGlCQUFVOzsyQ0FBMkI7QUFKeEMsMkJBZ0JDIn0=